"use client"

import Lenis from "lenis"
import { useEffect } from "react"

export default function SmoothScroll() {
    useEffect(() => {
        const preference = window.matchMedia("(prefers-reduced-motion: reduce)")
        let lenis: Lenis | undefined
        let frameId: number | undefined

        const stop = () => {
            if (frameId !== undefined) cancelAnimationFrame(frameId)
            lenis?.destroy()
            lenis = undefined
        }

        const update = (time: number) => {
            lenis?.raf(time)
            frameId = requestAnimationFrame(update)
        }

        const start = () => {
            stop()
            if (preference.matches) return
            lenis = new Lenis({
                duration: 0.7,
                orientation: "vertical",
                gestureOrientation: "vertical",
                smoothWheel: true,
            })
            frameId = requestAnimationFrame(update)
        }

        start()
        preference.addEventListener("change", start)

        return () => {
            preference.removeEventListener("change", start)
            stop()
        }
    }, [])

    return null
}
